import { buildMakeUseAxios } from "@api";
import type { IJob } from "@bbj-types/job";
import type { ISkill } from "@bbj-types/skill";
import { useCallback } from "react";

const axiosRome = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}`);

export interface IUseGetJobs {
  count: number;
  data: IJob[];
  limit: number;
  skip: number;
  total: number;
}

interface IGetJobsParams {
  libelle?: string;
  ids?: string[];
  removeDuplicateRome?: boolean;
}

export const useGetJob = () => {
  const [state, execute, cancel] = axiosRome<IUseGetJobs, string, unknown>(
    {
      url: "/romes/appellations",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (filters?: IGetJobsParams) => {
      return execute({
        url: `/romes/appellations`,
        params: filters,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

interface IGetSkillsFilters {
  libelle?: string;
  limit?: number;
  skip?: number;
}

export interface IGetSkills {
  limit: number;
  skip: number;
  count: number;
  total: number;
  data: readonly ISkill[];
}

export const useGetSkills = () => {
  const [state, execute, cancel] = axiosRome<IGetSkills>(
    {
      url: "/competences",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (filters: IGetSkillsFilters) => {
      return execute({
        url: `/competences`,
        params: filters,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
